import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import { getData } from '../../../webService/webservice.js';
import "../../../styles/Auth/department.css";
import "../../../styles/Auth/employee.css";
import { use } from 'react';
const DepartmentUserPage = () => {
    const role = sessionStorage.getItem("role");
    const adminStoreIds = JSON.parse(sessionStorage.getItem("storeIds") || "[]");
    const navigate = useNavigate();
    const { departmentId } = useParams();
    const [searchQuery, setSearchQuery] = useState('');
    const [users, setUsers] = useState([]);
    const [stores, setStores] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [employeeToDelete, setEmployeeToDelete] = useState(null);
    const [open, setOpen] = useState(false);
    const sessionToken = sessionStorage.getItem("Token");
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(5);
    const [departmentName, setDepartmentName] = useState("");
    const [selectedStoreId, setSelectedStoreId] = useState(
        sessionStorage.getItem("currentStoreId") || (role === "Admin" ? adminStoreIds[0] || "" : "")
    );
    const headings = [
        'SL',
        'Name',
        'Email',
        'Phone Number',
        'Store',
        'StaffId',
        'Action',
    ];
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const handleOpen = (departmentId) => {
        setEmployeeToDelete(departmentId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEmployeeToDelete(null);
    };

    const handleItemsPerPageChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    useEffect(() => {
        fetchusers(currentPage, limit, searchQuery, selectedStoreId);
    }, [currentPage, limit, searchQuery, refreshKey, selectedStoreId]);

    const fetchusers = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            name: searchQuery?.trim() || ""
        }
        if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData(`users/user/department/${departmentId}`, params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const employeeList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;
            setUsers(employeeList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch users");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const fetchDepartment = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const response = await getData(`departments/department/${departmentId}`, {}, token);
                const departmentData = response?.data;
                setDepartmentName(departmentData?.departmentName || "");
            } catch (error) {
                console.error("Failed to load department", error);
            }
        };
        fetchDepartment();
    }, [departmentId]);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = sessionStorage.getItem("currentStoreId");
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    return (
        <div className='department-layout'>
            <div className='department-content'>
                <div className='department-main'>
                    <div className="department-user-widgets">
                        <div className="employee-widgets-header">
                            <h3>
                                {departmentName ? ` ${departmentName}` : ""}
                            </h3>
                            <input
                                type="text"
                                placeholder="Search"
                                className="employee-search-input"
                                name="search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <TableContainer component={Paper} sx={{
                            borderRadius: '12px',
                            overflow: 'auto',
                            maxHeight: '400px',
                            '&::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                        }}>
                            <Table className="custom-employee-table"
                                sx={{
                                    '& td, & th': {
                                        border: 'none',
                                    },
                                    border: 'none',
                                }}>
                                <TableHead className="custom-employee-head">
                                    <TableRow sx={{ backgroundColor: '#F7EAE2' }}>
                                        {headings.map((heading, index) => (
                                            <TableCell
                                                key={index}
                                                sx={{
                                                    border: 'none',
                                                    padding: '12px 16px',
                                                    textAlign: 'center',

                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '4px',
                                                        color: '#000000',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {heading}
                                                </Typography>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {users.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                    No Users found.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        users.map((user, index) => (
                                            <TableRow key={user._id}>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                </TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{user.name || user.firstName}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{user.email}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{user.phoneNumber}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{user.storeDetails?.[0]?.storeName}</Typography></TableCell>
                                                <TableCell><Typography sx={commonCellStyle}>{user.staffId}</Typography></TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: 'pointer' }}
                                                            onClick={() => handleOpen(user._id)}
                                                        />
                                                    </Box>

                                                </TableCell>
                                            </TableRow>

                                        ))
                                    )}

                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="product-bottom">
                            <div className="product-section show-entries">
                                <span className="text-label">Show</span>
                                <select className="entries-select" value={limit}
                                    onChange={handleItemsPerPageChange}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                </select>
                                <span className="text-label">Entries</span>
                            </div>
                            <div className="product-section showing-range">
                                {`Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`}
                            </div>
                            <div className="product-section spacer"></div>
                            <div className="product-section pagination-buttons">
                                <button
                                    className="pagination-btn"
                                    onClick={() => navigate('/departments')}
                                >Back</button>
                            </div>
                        </div>
                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={modalStyle}>
                                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                    Confirm Remove?
                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                    Are you sure you want to remove a Employee from this department?
                                </Typography>

                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                    <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} >
                                        Yes, Remove
                                    </Button>
                                    <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepartmentUserPage;
